export default "__VITE_ASSET__EnLW4c4r__ 682w, __VITE_ASSET__aeGpTyDK__ 600w, __VITE_ASSET__df_xLRYj__ 400w";